import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddEscalationRequest } from '../models/request/escalation/AddEscalationRequest';
import { GetEscalationListPagingAndFilterRequest } from '../models/request/escalation/GetEscalationListPagingAndFilterRequest';

export class EscalationService {
    static async getEscalationListPagingAndFilter(inputObj: GetEscalationListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetEscalationListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/GetEscalationListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Listede kolon olacak maliyet kalemleri: yalnız kullanılmış olanlar. */
    static async getEscalationCostItemColumns() {
        try {
            console.log('SERVICE CALL - GetEscalationCostItemColumns');

            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/GetEscalationCostItemColumns', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addEscalation(inputObj: AddEscalationRequest) {
        try {
            console.log('SERVICE CALL - AddEscalation', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/AddEscalation', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getEscalationById(_id: string) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/GetEscalationById', { id: _id });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteEscalation(_ids: string[]) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/DeleteEscalation', { ids: _ids });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportEscalationList(inputObj: GetEscalationListPagingAndFilterRequest) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Escalation/ExportEscalationList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}
